export class TwoFaSettings {
  address: string;
  addressIsReadOnly: boolean;
  isConfirmed: boolean;
  confirmMessage: string;
  actionValue: string;
}
